<template>
  <div id="about-view">
    <h1>What <i>is</i> this tool?</h1>
    <p>
      This site was created to be a simple, easy to use resource in a moment of
      emotional turmoil. It's loosely based on DBT skills for emotion
      regulation. It's meant to be used
      <b>in the moment</b>, as a way to help change your emotional response to a
      given situation. Each 'solution' gives you some tips on how to regulate your
      emotions in a given situation. It's meant to be a quick read, with a
      change to make (where applicable). It should only take a couple of minutes
      to follow the provided 'solution' and take back some level of control of
      your emotional state. The more you practice these strategies, the easier
      and more second nature it will become to keep control of your emotions in
      tough situations.
    </p>
    <h1>What <i>isn't</i> this tool?</h1>
    <p>
      This site is not medical advice. It isn't written by a medical
      professional, rather made by someone likes to code and found these
      exercises invaluable when dealing with undesirable emotional responses to
      normal situations. The 'solutions' are not actual solutions, rather simple
      steps to be mindful of your emotions and react to situations more
      desirably.
    </p>
    <h1>A quick note...</h1>
    <p>
      These pieces of advice aren't always going to help you in the long run
      (for example using pride to gain control of shame might not be a good long
      term strategy), but they can potentially help you in the moment. You can
      use them before a meeting, when you walk into a party, during a tough
      conversation, or any other scenario where you need to very quickly change
      your reaction to something.
    </p>
    <p>
      If you're struggling with severe depression, anxiety, suicidal thoughts or
      any other chronic mood disorder please seek help immediately. Therapy is an invaluable tool
      for coping / treatment and <a href="https://suicidepreventionlifeline.org/" target="_blank" >the national
      suicide hotline</a> provides free, confidential support 24/7.
    </p>
  </div>
</template>

<script>
export default {
  name: "AboutView",
  methods: {}
};
</script>

<style scoped>
#about-view {
  margin: 0 auto;
  padding: 30px;
  max-width: 600px;
}
p {
  text-align: left;
}
</style>
